import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    window.location.href = "https://t.me/Sirfix12";
  }, []);

  return null;
}

export default App;